module.exports = __webpack_public_path__ + "static/pt-and-8b63ecad621cb86fec8beb47733d2dec.png";